const dayjsTranslations = {
  'en-US': {
    name: 'en', // name String
    weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'], // weekdays Array
    months: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    ordinal: n => `${n}º`, // ordinal Function (number) => return number + output
    formats: {
      // abbreviated format options allowing localization
      LTS: 'h:mm:ss A',
      LT: 'h:mm A',
      L: 'MM/DD/YYYY',
      LL: 'MMMM D, YYYY',
      LLL: 'MMMM D, YYYY h:mm A',
      LLLL: 'dddd, MMMM D, YYYY h:mm A',
      // lowercase/short, optional formats for localization
      l: 'D/M/YYYY',
      ll: 'D MMM, YYYY',
      lll: 'D MMM, YYYY h:mm A',
      llll: 'ddd, MMM D, YYYY h:mm A',
    },
    relativeTime: {
      // relative time format strings, keep %s %d as the same
      future: 'in %s', // e.g. in 2 hours, %s been replaced with 2hours
      past: '%s ago',
      s: 'a few seconds',
      m: 'a minute',
      mm: '%d minutes',
      h: 'an hour',
      hh: '%d hours', // e.g. 2 hours, %d been replaced with 2
      d: 'a day',
      dd: '%d days',
      M: 'a month',
      MM: '%d months',
      y: 'a year',
      yy: '%d years',
    },
    meridiem: hour => {
      // OPTIONAL, AM/PM
      return hour > 12 ? 'PM' : 'AM';
    },
  },
  'es-MX': {
    name: 'es', // name String
    weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'], // weekdays Array
    months: [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ],
    ordinal: n => `${n}º`, // ordinal Function (number) => return number + output
    formats: {
      // abbreviated format options allowing localization
      LTS: 'h:mm:ss A',
      LT: 'h:mm A',
      L: 'MM/DD/YYYY',
      LL: 'MMMM D, YYYY',
      LLL: 'MMMM D, YYYY h:mm A',
      LLLL: 'dddd, MMMM D, YYYY h:mm A',
      // lowercase/short, optional formats for localization
      l: 'D/M/YYYY',
      ll: 'D MMM, YYYY',
      lll: 'D MMM, YYYY h:mm A',
      llll: 'ddd, MMM D, YYYY h:mm A',
    },
    relativeTime: {
      // relative time format strings, keep %s %d as the same
      future: 'en %s', // e.g. in 2 hours, %s been replaced with 2hours
      past: 'hace %s',
      s: 'unos segundos',
      m: 'un minuto',
      mm: '%d minutos',
      h: 'una hora',
      hh: '%d horas', // e.g. 2 hours, %d been replaced with 2
      d: 'un día',
      dd: '%d días',
      M: 'un mes',
      MM: '%d meses',
      y: 'un año',
      yy: '%d años',
    },
    meridiem: hour => {
      // OPTIONAL, AM/PM
      return hour > 12 ? 'PM' : 'AM';
    },
  },
  'fr-FR': {
    name: 'fr', // name String
    weekdays: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'], // weekdays Array
    months: [
      'Janvier',
      'Février',
      'Mars',
      'Avril',
      'Mai',
      'Juin',
      'Juillet',
      'Août',
      'Septembre',
      'Octobre',
      'Novembre',
      'Décembre',
    ],
    ordinal: n => `${n}º`, // ordinal Function (number) => return number + output
    formats: {
      // abbreviated format options allowing localization
      LTS: 'HH:mm:ss',
      LT: 'HH:mm',
      L: 'DD/MM/YYYY',
      LL: 'D MMMM YYYY',
      LLL: 'D MMMM YYYY HH:mm',
      LLLL: 'dddd D MMMM YYYY HH:mm',
      // lowercase/short, optional formats for localization
      l: 'D/M/YYYY',
      ll: 'D MMM YYYY',
      lll: 'D MMM YYYY HH:mm',
      llll: 'ddd D MMM YYYY HH:mm',
    },
    relativeTime: {
      // relative time format strings, keep %s %d as the same
      future: 'dans %s', // e.g. in 2 hours, %s been replaced with 2hours
      past: 'il y a %s',
      s: 'quelques secondes',
      m: 'une minute',
      mm: '%d minutes',
      h: 'une heure',
      hh: '%d heures', // e.g. 2 hours, %d been replaced with 2
      d: 'un jour',
      dd: '%d jours',
      M: 'un mois',
      MM: '%d mois',
      y: 'un an',
      yy: '%d ans',
    },
    meridiem: hour => {
      // OPTIONAL, AM/PM
      return hour > 12 ? 'PM' : 'AM';
    },
  },
  'pt-BR': {
    name: 'pt', // name String
    weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'], // weekdays Array
    months: [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ],
    ordinal: n => `${n}º`, // ordinal Function (number) => return number + output
    formats: {
      // abbreviated format options allowing localization
      LTS: 'HH:mm:ss',
      LT: 'HH:mm',
      L: 'DD/MM/YYYY',
      LL: 'D [de] MMMM [de] YYYY',
      LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
      LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
      // lowercase/short, optional formats for localization
      l: 'DD/MM/YYYY',
      ll: 'D [de] MMM [de] YYYY',
      lll: 'D [de] MMM [de] YYYY [às] HH:mm',
      llll: 'ddd, D [de] MMM [de] YYYY [às] HH:mm',
    },
    relativeTime: {
      // relative time format strings, keep %s %d as the same
      future: 'em %s', // e.g. in 2 hours, %s been replaced with 2hours
      past: '%s atrás',
      s: 'alguns segundos',
      m: 'um minuto',
      mm: '%d minutos',
      h: 'uma hora',
      hh: '%d horas', // e.g. 2 hours, %d been replaced with 2
      d: 'um dia',
      dd: '%d dias',
      M: 'um mês',
      MM: '%d meses',
      y: 'um ano',
      yy: '%d anos',
    },
    meridiem: hour => {
      // OPTIONAL, AM/PM
      return hour > 12 ? 'PM' : 'AM';
    },
  },
  'nl-NL': {
    name: 'nl', // name String
    weekdays: ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'], // weekdays Array
    months: [
      'Januari',
      'Februari',
      'Maart',
      'April',
      'Mei',
      'Juni',
      'Juli',
      'Augustus',
      'September',
      'Oktober',
      'November',
      'December',
    ],
    ordinal: n => `${n}e`, // ordinal Function (number) => return number + output
    formats: {
      // abbreviated format options allowing localization
      LTS: 'HH:mm:ss',
      LT: 'HH:mm',
      L: 'DD/MM/YYYY',
      LL: 'D MMMM YYYY',
      LLL: 'D MMMM YYYY HH:mm',
      LLLL: 'dddd D MMMM YYYY HH:mm',
      // lowercase/short, optional formats for localization
      l: 'D/M/YYYY',
      ll: 'D MMM YYYY',
      lll: 'D MMM YYYY HH:mm',
      llll: 'ddd D MMM YYYY HH:mm',
    },
    relativeTime: {
      // relative time format strings, keep %s %d as the same
      future: 'over %s', // e.g. in 2 hours, %s been replaced with 2hours
      past: '%s geleden',
      s: 'een paar seconden',
      m: 'een minuut',
      mm: '%d minuten',
      h: 'een uur',
      hh: '%d uren', // e.g. 2 hours, %d been replaced with 2
      d: 'een dag',
      dd: '%d dagen',
      M: 'een maand',
      MM: '%d maanden',
      y: 'een jaar',
      yy: '%d jaren',
    },
    meridiem: hour => {
      // OPTIONAL, AM/PM
      return hour > 12 ? 'PM' : 'AM';
    },
  },
  'zh-CN': {
    name: 'zh-cn', // name String
    weekdays: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'], // weekdays Array
    months: [
      '一月',
      '二月',
      '三月',
      '四月',
      '五月',
      '六月',
      '七月',
      '八月',
      '九月',
      '十月',
      '十一月',
      '十二月',
    ],
    monthsShort: [
      '1月',
      '2月',
      '3月',
      '4月',
      '5月',
      '6月',
      '7月',
      '8月',
      '9月',
      '10月',
      '11月',
      '12月',
    ],
    ordinal: n => `第${n}`, // ordinal Function (number) => return number + output
    formats: {
      // abbreviated format options allowing localization
      LTS: 'HH:mm:ss',
      LT: 'HH:mm',
      L: 'YYYY/MM/DD',
      LL: 'YYYY年MM月DD日',
      LLL: 'YYYY年MM月DD日 HH:mm',
      LLLL: 'dddd YYYY年MM月DD日 HH:mm',
      // lowercase/short, optional formats for localization
      l: 'YYYY/M/D',
      ll: 'YYYY年MM月DD日',
      lll: 'YYYY年MM月DD日 HH:mm',
      llll: 'ddd YYYY年MM月DD日 HH:mm',
    },
    relativeTime: {
      // relative time format strings, keep %s %d as the same
      future: '%s后', // e.g. in 2 hours, %s been replaced with 2hours
      past: '%s前',
      s: '几秒',
      m: '1分钟',
      mm: '%d分钟',
      h: '1小时',
      hh: '%d小时', // e.g. 2 hours, %d been replaced with 2
      d: '1天',
      dd: '%d天',
      M: '1个月',
      MM: '%d个月',
      y: '1年',
      yy: '%d年',
    },
    meridiem: hour => {
      // OPTIONAL, AM/PM
      return hour > 12 ? '下午' : '上午';
    },
  },
};

export default dayjsTranslations;
